import { useCallback } from "react";

import { Grid } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";

export const ThemedDotSelector = ({
  isSelected,
  setSelectedIndex,
  index,
  size,
}: {
  isSelected: boolean;
  setSelectedIndex: (index: number) => void;
  index: number;
  size: "small" | "medium" | "large";
}) => {
  const width = size === "large" ? 32 : size === "medium" ? 18 : 8;
  const handleClick = useCallback(() => {
    if (isSelected) {
      return;
    }
    setSelectedIndex(index);
  }, [index, isSelected, setSelectedIndex]);

  const dynamicTheme = useDynamicThemeAwareVariables(({ formsPalette, mode }) => {
    return {
      backgroundColorSelected: mode === "light" ? formsPalette.text.brand : formsPalette.text.moderate,
      backgroundColorUnselected: formsPalette.border.moderate,
    };
  });

  return (
    <Grid
      onClick={handleClick}
      sx={{
        width,
        height: width,
        backgroundColor: isSelected ? dynamicTheme.backgroundColorSelected : dynamicTheme.backgroundColorUnselected,
        cursor: isSelected ? "default" : "pointer",
        borderRadius: "50%",
      }}
    />
  );
};
